<h1  mat-dialog-title *ngIf="action_type==='create'">Crear una nueva capa</h1>
<h1  mat-dialog-title *ngIf="action_type==='edit'">Editar capa</h1>

<mat-dialog-content  class="create-layer">
        <mat-form-field>
            <input matInput  [disabled]="false" placeholder="Nombre de la Capa" required [(ngModel)]="name">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Categoría Capa</mat-label>
                <mat-select required [(ngModel)]="category">
                    <mat-option *ngFor="let category of categories" [value]="category.categoria_capa_id">
                        {{category.categoria_capa_nombre}}
                    </mat-option>
                </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Geometría Capa</mat-label>
                <mat-select required [(ngModel)]="geometry">
                    <mat-option *ngFor="let geometry of geometries" [value]="geometry.value">
                        {{geometry.description}}
                    </mat-option>
                </mat-select>
        </mat-form-field>
        <mat-form-field>
            <input matInput  [disabled]="false" placeholder="Descripción" required [(ngModel)]="description">
        </mat-form-field>
    </mat-dialog-content>
<mat-dialog-actions>
    <button  mat-raised-button *ngIf="action_type==='create'" (click)="createLayer()">Crear</button>
    <button  mat-raised-button *ngIf="action_type==='edit'" (click)="editLayer()">Editar</button>
    <button  mat-raised-button (click)="closeMe()">Cancelar</button>
</mat-dialog-actions>

